export default 'webkitTransition' in document.head.style || 'transition' in document.head.style;